import React, { useState } from 'react';
import { Layers, Users, Database, Building2, Calendar } from 'lucide-react';
import IntegrationTimeline from './IntegrationTimeline';
import SynergyTracker from './SynergyTracker';
import WorkstreamStatus from './WorkstreamStatus';
import IntegrationMetrics from './IntegrationMetrics';
import { useDeals } from '../../store/DealsContext';
import { useIntegration } from '../../hooks/useIntegration';

export default function IntegrationDashboard() {
  const { deals } = useDeals();
  const [selectedDeal, setSelectedDeal] = useState<string>('');
  const { workstreams, synergies, milestones, loading } = useIntegration(selectedDeal);

  const workstreamTypes = [
    { id: 'it', name: 'IT Systems', icon: Database },
    { id: 'hr', name: 'Human Resources', icon: Users },
    { id: 'operations', name: 'Operations', icon: Building2 },
    { id: 'finance', name: 'Finance', icon: Layers }
  ];

  return (
    <div className="h-full space-y-6">
      <div className="flex justify-between items-start">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Integration Planning</h2>
          <p className="mt-2 text-gray-600">Track and manage post-merger integration</p>
        </div>
        
        <select
          value={selectedDeal}
          onChange={(e) => setSelectedDeal(e.target.value)}
          className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">Select Deal</option>
          {deals.map((deal) => (
            <option key={deal.id} value={deal.id}>{deal.name}</option>
          ))}
        </select>
      </div>

      <IntegrationMetrics workstreams={workstreams} synergies={synergies} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow-sm">
          <div className="px-6 py-4 border-b border-gray-200">
            <h3 className="text-lg font-medium text-gray-900">Integration Timeline</h3>
          </div>
          <div className="p-6">
            <IntegrationTimeline milestones={milestones} />
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm">
          <div className="px-6 py-4 border-b border-gray-200">
            <h3 className="text-lg font-medium text-gray-900">Synergy Tracking</h3>
          </div>
          <div className="p-6">
            <SynergyTracker synergies={synergies} />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">Workstream Status</h3>
        </div>
        <div className="p-6">
          <WorkstreamStatus workstreams={workstreams} workstreamTypes={workstreamTypes} />
        </div>
      </div>
    </div>
  );
}